module.exports = __webpack_public_path__ + "static/media/add-inside-circle-dark.c56d9e8d.svg";